/* proxies */
import SalaryCleanerBaseProxy from '../../proxies/Salary/SalaryCleanerBaseProxy';

export default {
  data() {
    return {
      updatingData: {},
    };
  },
  methods: {
    updateSimpleRequest(salary, property) {
      return (value) => {
        const data = {};
        data[property] = value;
        console.warn(salary);
        this.updatingData[salary.salary_identifier] = true;
        this.$forceUpdate();
        return new SalaryCleanerBaseProxy().update(salary.salary_identifier, data)
          .then((response) => {
            salary[property] = response.data.data.salary[property];
          })
          .finally(() => {
            delete this.updatingData[salary.salary_identifier];
            this.$forceUpdate();
          });
      };
    },
  },
};
